const obraSelecionada = JSON.parse(sessionStorage.getItem('obraSelecionada') ?? localStorage.getItem('ultimaObraSelecionada') ?? '{}');
const codigoContrato = parseInt(sessionStorage.getItem('codigoContrato') ?? localStorage.getItem('ultimoCodigoContratoSelecionado') ?? 'NaN');

export type State = {
  obraSelecionada: object | null;
  codigoContrato: number;
  contratosUsuario: any[];
  obrasUsuario: any[];
};

export const state: State = {
  obraSelecionada: obraSelecionada,
  codigoContrato: codigoContrato,
  contratosUsuario: [],
  obrasUsuario: []
};
